import { createAction } from 'typesafe-actions';
import { IPumpingStationPumpType } from '../../../../@types/model/masterData/pumpingStation/pumpType';

export default class MasterDataPumpingStationPumpTypeActions {
    public static readonly set = createAction('MASTER_DATA_SET_PUMPING_STATION_PUMP_TYPES', resolve => (pumps : Array<IPumpingStationPumpType>) => resolve(pumps));
    public static readonly setLoading = createAction('MASTER_DATA_SET_PUMPING_STATION_PUMP_TYPES_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}